import { gql } from '@apollo/client';

export const GQL_PUB_LINK_PROCESS = gql`
  mutation LinkProcess($_id: ID, $modelName: String, $remove: Boolean) {
    linkProcess(_id: $_id, modelName: $modelName, remove: $remove)
  }
`;
